export default function perlBoolean(value: any) {
  // AJAX requests go through Gurupa, which because Perl returns '0' instead of false

  switch(value) {
    case '0':
      return false
    case '1':
      return true
    default:
      return value
  }
}
